//DEFAULTS
import "imports/core-js/stable";
import "imports/regenerator-runtime/runtime";

import stickSite from 'site/site'
import slides from 'site/slides'
import gsap, { Power2, Linear } from 'imports/gsap'
$(document).ready(function() {
    //stickOverlay.init()
    stickSite.init()
    slides.init()

    //svg animation
    let tl = gsap.timeline({repeat:0, delay:1});
    let tme = 2
    let stagger = "-=1.75"
    let defaultFrom = {
        opacity: 0,
        //'-webkit-filter':'grayscale(100%) blur(5px)',
        //filter: 'grayscale(100%) blur(5px)',
        '-webkit-filter':'grayscale(100%)',
        filter: 'grayscale(100%)',
    }
    let defaultTo = {
        opacity: 1,
        duration:tme,
        //'-webkit-filter':'grayscale(0%) blur(0px)',
        //filter: 'grayscale(0%) blur(0px)',
        '-webkit-filter':'grayscale(0%)',
        filter: 'grayscale(0%)',
        ease: Power2.easeInOut,
    }
    let defaultFromClip = { ...defaultFrom }
    let defaultToClip = { ...defaultTo }
    defaultFromClip["clip-path"] = "circle(0% at 50% 50%)"
    defaultToClip["clip-path"] = "circle(100% at 50% 50%)"
    tl.fromTo('.logo-vid', defaultFromClip, defaultToClip, 0)
    tl.fromTo('.logline', defaultFrom, defaultTo, stagger)
    tl.fromTo('.releases', defaultFrom, defaultTo, stagger)
    tl.fromTo('.films .film', defaultFrom, defaultTo, stagger)
    tl.fromTo('.films .swiper-button-next', defaultFrom, defaultTo, stagger)
    tl.fromTo('.films .swiper-button-prev', defaultFrom, defaultTo, stagger)

    tl.fromTo('.btns .btn', defaultFrom, defaultTo, stagger)
    tl.fromTo('.social', defaultFrom, defaultTo, stagger)
    tl.fromTo('.anchored-content', defaultFrom, defaultTo, stagger)
})
